
export const GET_BANKS = "GET_BANKS";
export const ACCOUNT_ADDED = 'ACCOUNT_ADDED';
export const ACCOUNT_UPDATED = 'ACCOUNT_UPDATED';
export const ACCOUNT_ERROR = 'ACCOUNT_ERROR';
export const SELECT_ACCOUNT = 'SELECT_ACCOUNT';
export const GENERATE_OTP_BANK = 'GENERATE_OTP';
export const DELETE_OTP_BANK = 'DELETE_OTP_BANK';